export const RESET_IMPORT_EMPLOYEES = "reset_import_employee";
export const IMPORT_EMPLOYEES = "import_employee";
export const IMPORT_EMPLOYEES_SUCCESS = "import_employee_success";
export const IMPORT_EMPLOYEES_FAILURE = "import_employee_failure";
